import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet, axiosDelete, axiosPatch } from "./axiosFunctions";


const getViewUserAllUrl                                  = '/api/admin/users/getViewUserAll';
const getIsAppUserUrl                                    = '/api/admin/users/getIsAppUser';
const getPrimaryViewUserUrl                              = '/api/admin/users/getPrimaryViewUser';
const getActiveViewUserAllUrl                            = '/api/admin/users/getActiveViewUserAll';
const getGolfUsersUrl                                    = (type) =>`/api/admin/users/getGolfUsers/${type}`;
const getUserAllUrl                                      = '/api/admin/users/getUserAll';
const getMobileCodeUrl                                   = '/api/admin/users/getMobileCodeAll';
const getGuestAllUrl                                     = '/api/admin/users/getGuestAll';
const getMobileCodeAllUrl                                = '/api/admin/users/getMobileCodeAll';
const addUserUrl                                         = '/api/admin/users/addUser';
const postMemberUrl                                      = '/api/admin/users/postMember';
const updateMemberGroupUrl                               = '/api/admin/users/updateMemberGroup';
const verifyMembershipNoUrl                              = '/api/admin/users/verifyMembershipNo';
const verifyMobileNoUrl                                  = '/api/admin/users/verifyMobileNo';
const postMemberDocumentUrl                              = '/api/admin/users/postMemberDocument';
const getMemberDocumentsByGroupIDUrl                     = (groupID) => `/api/admin/users/getMemberDocumentsByGroupID/${groupID}`;
const deleteMemberDocumentsByIDAndGroupIDUrl             = (id, groupID) => `/api/admin/users/deleteMemberDocumentsByIDAndGroupID/${id}/${groupID}`;
const postGuestUrl                                       = '/api/admin/users/postGuest';
const sendGuestOTPUrl                                    = (mobile, id) => `/api/admin/users/sendGuestOTP/${mobile}/${id}`;
const updateUserHandicapUrl                              = (id, handicap, handicapIndex) => `/api/admin/users/updateUserHandicap/${id}/${handicap}/${handicapIndex}`;
const processFileUrl                                     = '/api/admin/users/processFile';
const getViewSubscriptionExpiredAndPrimaryUserUrl        = '/api/admin/users/getViewSubscriptionExpiredAndPrimaryUserAll';
const getMembershipTypesUrl                              = '/api/admin/users/getMembershipType';
const getMembershipTermsByTypeIDUrl                      = (typeID) => `/api/admin/users/getMembershipTermByTypeID/${typeID}`;
const getMembershipCategoriesUrl                         = '/api/admin/users/getMembershipCategories';
const getMembershipTypeAndCategoryUrl                    = '/api/admin/users/getMembershipTypeAndCategory';
const getGuestSubCategoriesByCategoryIDUrl               = (categoryID) => `/api/admin/users/getGuestSubCategoryByCategoryID/${categoryID}`;
const getAllMembersUrl                                   = '/api/admin/users/getAllMembers';

export const getViewUserAll = async () => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getViewUserAllUrl,
       { headers: '' }
    );
    return response;
};

export const getIsAppUser = async () => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getIsAppUserUrl,
       { headers: '' }
    );
    return response;
};

export const getPrimaryViewUser = async () => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
      getPrimaryViewUserUrl,
       { headers: '' }
    );
    return response;
};

export const getActiveViewUserAll = async () => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getActiveViewUserAllUrl,
     { headers: '' }
  );
  return response;
};

export const getGolfUsers = async (type) => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
      getGolfUsersUrl(type),
       { headers: '' }
    );
    return response;
};

export const getUserAll = async () => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getUserAllUrl,
       { headers: '' }
    );
    return response;
};

export const addUser = async (userList, memberGroup, subscriptionValidity, documentList) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
        addUserUrl,
      {  userList, memberGroup,subscriptionValidity, documentList},
       { headers: '' }
    );
    return response;
};

export const postMember = async (user) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
      postMemberUrl,
      {  user },
       { headers: '' }
    );
    return response;
};

export const updateMemberGroup = async (memberDetails) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
      updateMemberGroupUrl,
      {  memberDetails },
       { headers: '' }
    );
    return response;
};


export const verifyMembershipNo = async (membershipNo) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
      verifyMembershipNoUrl,
      {  membershipNo },
       { headers: '' }
    );
    return response;
};

export const verifyMobileNo = async (mobileNo) => {
    // const token = getAuthState('token');
    // if (!token) setTimeout(()=> { return }, 2000);
    
    const response = await axiosPost(
      verifyMobileNoUrl,
      {  mobileNo },
       { headers: '' }
    );
    return response;
};

export const postMemberDocument = async (documentDetails) => {
  // const token = getAuthState('token');
  // if (!token) setTimeout(()=> { return }, 2000);
  
  const response = await axiosPost(
    postMemberDocumentUrl,
    {  documentDetails },
     { headers: '' }
  );
  return response;
}

export const getMemberDocumentsByGroupID = async (groupID) => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getMemberDocumentsByGroupIDUrl(groupID),
     { headers: '' }
  );
  return response;
};

export const deleteMemberDocumentsByIDAndGroupID = async (id, groupID) => {
  // const token = getAuthState('token');
  // if (!token) setTimeout(()=> { return }, 2000);
  
  const response = await axiosDelete(
     deleteMemberDocumentsByIDAndGroupIDUrl(id, groupID),
     { headers: '' }
  );
  return response;
};

export const getMobileCode = async () => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getMobileCodeUrl,
     { headers: '' }
  );
  return response;
};

export const getGuestAll = async () => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getGuestAllUrl,
     { headers: '' }
  );
  return response;
};

export const getMobileCodeAll = async () => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getMobileCodeAllUrl,
     { headers: '' }
  );
  return response;
};

export const postGuest = async (guest, otp, sessionId) => {
  // const token = getAuthState('token');
  // if (!token) setTimeout(()=> { return }, 2000);
  
  const response = await axiosPost(
    postGuestUrl,
    {  guest },
     { headers: '' }
  );
  return response;
};

export const sendGuestOTP = async (mobile, id) => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    sendGuestOTPUrl(mobile, id),
     { headers: '' }
  );
  return response;
};

export const updateUserHandicap = async (id, handicap, handicapIndex) => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    updateUserHandicapUrl(id, handicap, handicapIndex),
     { headers: '' }
  );
  return response;
};

export const processFile = async (userHandicap, selectedDate) => {
  // const token = getAuthState('token');
  // if (!token) setTimeout(()=> { return }, 2000);
  
  const response = await axiosPost(
    processFileUrl,
    { userHandicap, selectedDate },
     { headers: '' }
  );
  return response;
};

export const getViewSubscriptionExpiredAndPrimaryUser = async () => {
     //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getViewSubscriptionExpiredAndPrimaryUserUrl,
       { headers: '' }
    );
    return response;
};

export const getMembershipTypes = async () => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getMembershipTypesUrl,
    { headers: '' }
    // { headers: {auth_token: `bearer ${token}`} }
  );
  return response;
};

export const getMembershipTermsByTypeID = async (typeID) => {
  //const token = getAuthState('token');
    //if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getMembershipTermsByTypeIDUrl(typeID),
    { headers: '' }
    // { headers: {auth_token: `bearer ${token}`} }
  );
  return response;
};

export const getMembershipCategories = async () => {
  // const token = getAuthState('token');
  // if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getMembershipCategoriesUrl,
    { headers: '' }
    // { headers: {auth_token: `bearer ${token}`} }
  );
  return response;
};


export const getMembershipTypeAndCategory = async () => {

  const response = await axiosGet(
    getMembershipTypeAndCategoryUrl,
    { headers: '' }   
  );
  return response;
};


export const getAllMembers = async (typeID) => {

  const response = await axiosGet(
    getAllMembersUrl,
    { headers: '' }
  );
  return response;
};


export const getGuestSubCategoriesByCategoryID = async (categoryID) => {
      
    const response = await axiosGet( getGuestSubCategoriesByCategoryIDUrl(categoryID), { headers: '' } );
    return response;
};

